import Configuration from "./configuration";

class LoanService {
  constructor(token, user) {
    this.config = new Configuration(token, user, "api/Loan");
  }

  /**
   * @method getLoanType list of notifications for user
   * @return {Promise} result object notifications
   */
  getLoanType() {
    return this.config.API.get(`GetLoanType`).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method loanSimulate list of notifications for user
   * @return {Promise} result object notifications
   */
  loanSimulate() {
    return this.config.API.post(`LoanSimulate`, {
      creditRequest: 1500000,
      guaranteeCode: "0001",
      id: "93339108",
      initialDatePayment: "2020-01-31T12:59:26.465Z",
      loanCost: null,
      loanDestination: "LNGU",
      loanType: "CONS",
      maxFee: 1500000,
      term: 12,
      typeFee: "Constant"
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }
}

export default LoanService;
